// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyARr9uIYPqlLLmOe84kDKf6ORDYFOwtHDA",
  authDomain: "testmentor-27b57.firebaseapp.com",
  projectId: "testmentor-27b57",
  storageBucket: "testmentor-27b57.appspot.com",
  messagingSenderId: "558206799524",
  appId: "1:558206799524:web:b72d511a102af450432031"
};

// Initialize Firebase
const firebase = initializeApp(firebaseConfig);
export const auth = getAuth(firebase);

export default firebase